// extracted by mini-css-extract-plugin
export default {"Snow":"snow_Snow__sdfrp","Snowflake":"snow_Snowflake__dvuf3","fall":"snow_fall__8e-g-"};